<template>
  <DxLoadPanel :visible="loading" shading-color="rgba(0, 0, 0, 0.2)"></DxLoadPanel>
</template>

<script setup lang="ts">
import {DxLoadPanel} from "devextreme-vue";
import {onOperationsChanged} from "@services/loading-service";
import {ref} from "vue";

const loading = ref(false);
const busSubscription = onOperationsChanged((v) => loading.value = v.operations.length > 0);

</script>

